import React from 'react';
import { updateWrapper } from '@confluence/web-panel-location/entry-points/breakoutConsts';

/**
 * Inline Script that updates breakout node width on client side,
 * before main JavaScript bundle is ready.
 *
 * More info: https://product-fabric.atlassian.net/wiki/spaces/E/pages/1216218119/Renderer+SSR+for+Breakout+Nodes
 */
export function BreakoutSSRInlineScript() {
	/**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */
	if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
		return null;
	}
	const context = createBreakoutInlineScript();
	return (
		<script
			// To investigate if we can replace this.
			// eslint-disable-next-line react/no-danger
			dangerouslySetInnerHTML={{ __html: context }}
		></script>
	);
}

export function createBreakoutInlineScript() {
	return `
  (function(window){
		${breakoutInlineScriptContext};
    (${applyBreakoutAfterSSR.toString()})(breakoutConstsInner);
  })(window);
`;
}

export const breakoutInlineScriptContext = `
	var breakoutConstsInner = {}; 
  breakoutConstsInner.updateWrapper = ${updateWrapper.toString()};
`;

export function applyBreakoutAfterSSR(breakoutConstsInner) {
	const breakoutContainer = document.querySelector(
		"[data-connect-container='fixed-atl-general-wrapper']",
	);
	if (!breakoutContainer) {
		return;
	}
	breakoutConstsInner?.updateWrapper(breakoutContainer);
}
